import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { authService, User } from '../utils/auth'
import AuthModal from './AuthModal'

function Header() {
  const [user, setUser] = useState<User | null>(null)
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false)

  useEffect(() => {
    setUser(authService.getCurrentUser())
    
    const unsubscribe = authService.subscribe((newUser) => {
      setUser(newUser)
      
      // Handle pending actions after login
      if (newUser && !user) {
        const pendingAction = authService.executePendingAction()
        if (pendingAction) {
          // Execute the pending action
          setTimeout(() => {
            if (pendingAction.type === 'purchase') {
              // Re-trigger the purchase workflow
              window.dispatchEvent(new CustomEvent('completePendingPurchase', { 
                detail: pendingAction.data 
              }))
            } else if (pendingAction.type === 'booking') {
              // Re-trigger the booking workflow
              window.dispatchEvent(new CustomEvent('completePendingBooking', { 
                detail: pendingAction.data 
              }))
            }
          }, 500) // Small delay to ensure UI is ready
        }
      }
    })

    // Listen for auth required events
    const handleAuthRequired = () => {
      setIsAuthModalOpen(true)
    }

    window.addEventListener('authRequired', handleAuthRequired)

    return () => {
      unsubscribe()
      window.removeEventListener('authRequired', handleAuthRequired)
    }
  }, [user])
  return (
    <header className="py-3">
      <nav className="navbar navbar-expand-lg">
        <div className="container-fluid px-4">
          <Link to="/" className="navbar-brand fs-1 fw-bold text-dark">
            <span className="me-3 fs-1">🧜‍♀️</span>
            The Salty Mermaid
          </Link>
          
          <button 
            className="navbar-toggler" 
            type="button" 
            data-bs-toggle="collapse" 
            data-bs-target="#navbarNav"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav mx-auto">
              <li className="nav-item">
                <Link to="/" className="nav-link fs-5 fw-medium">Home</Link>
              </li>
              <li className="nav-item">
                <Link to="/classes" className="nav-link fs-5 fw-medium">Classes</Link>
              </li>
              <li className="nav-item">
                <Link to="/about" className="nav-link fs-5 fw-medium">About</Link>
              </li>
              <li className="nav-item">
                <Link to="/contact" className="nav-link fs-5 fw-medium">Contact</Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      
      <AuthModal 
        isOpen={isAuthModalOpen}
        onClose={() => setIsAuthModalOpen(false)}
      />
    </header>
  )
}

export default Header